import {
    default as actions,
    UPDATE,
    ADD,
    LIST,
    REMOVE,
    SELECTED,
    SPRITE_SAVE,
    SPRITE_REMOVE_EXT,
    SPRITE_EDIT_MODE,
    SPRITE_CLEAN_FILELIST,
    SPRITE_CHECKED,
    SPRITE_MERGE,
    SPRITE_SEARCH,
    SPRITE_TYPE,
    SPRITE_CLASSIFY_CHANGE,
    SPRITE_PAGINATION_CHANGE
} from './action';

const defaultState = {
    type: '',
    // 角色列表
    libs: [],
    // 用户自定义角色库
    user_libs: [],
    // 造型库
    costumes: [],
    // 用户自定义造型库
    user_costumes: [],
    // 背景列表
    backdrops: [],
    // 用户自定义背景库
    user_backdrops: [],
    // 音效列表
    sounds: [],
    // 用户自定义声音库
    user_sounds: [],
    // 选中的元素
    selected: {},
    // 设置上传fileList原始值
    originFilstList: {},
    // 上传的文件列表
    fileList: [],
    // 编辑状态
    isEdit: false,
    // 选择的索引
    checkedIndex: [],
    // 查询的字符串
    searchText: '',
    // 备份数据
    backup: {},
    // 删除状态
    removeExtRequest: '',
    // 角色、背景分类标签
    classify: 'All',
    // 角色、背景分页起始下标、结束下标
    paginationSettings: {
        signStart: 0,
        signEnd: 50,
        defaultPageSize: 50,
        current: 1
    },
    // 是否在上传角色后换页
    isChangePageAfterUpload: false,
    // 是否正在添加
    isAdding: false
};

const reducer = (state = defaultState, action) => {
    switch (action.type) {
        case LIST:
        case ADD:
        case SELECTED:
        case REMOVE:
        case SPRITE_SAVE:
        case SPRITE_REMOVE_EXT:
        case SPRITE_EDIT_MODE:
        case SPRITE_CLEAN_FILELIST:
        case SPRITE_CHECKED:
        case SPRITE_SEARCH:
        case SPRITE_TYPE:
        case SPRITE_MERGE:
        case SPRITE_CLASSIFY_CHANGE:
        case SPRITE_PAGINATION_CHANGE:
            return Object.assign({}, state, action.payload);
        case UPDATE:
            action.payload[action.spriteType] = action.payload[action.spriteType].concat(state[action.spriteType]);
            return Object.assign({}, state, action.payload);
        default:
            return state;
    }
};

export default {
    reducer,
    actions
};